import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { buildContexteFromUrlSearch } from '../utils/url';

/**
 * Hook to get contexte from URL query parameters as JSON string.
 * UI-only params (e.g. table pagination `page`) are excluded so API queries stay stable.
 * @returns {string | null} - The contexte as JSON string (e.g., '{"id_soiree":"13279899"}') or null if no context
 */
export const useContexte = () => {
  const [searchParams] = useSearchParams();

  const contexte = useMemo(() => {
    const searchString = searchParams.toString();
    const fullSearchString = searchString ? `?${searchString}` : '';

    return buildContexteFromUrlSearch(fullSearchString);
  }, [searchParams]);

  return contexte;
};
